export default __webpack_public_path__ + "static/non-contact-1f68466e14873b8f350a298acd47b78a.jpg";